export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML тексеру"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мекенжайды енгізіп, блокчейнді таңдаңыз — біз жылдам скрининг жүргіземіз."])}
}